/**
 * Custom JS
 */
(function($) {
    $(document).ready(function() {
        /**
         * mobile menu opening
         */
        // $('.off-canvas--open .fw--icon--menu').on('click', function() {
        //     var scrollPosition = [
        //         self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
        //         self.pageYOffset || document.documentElement.scrollTop  || document.body.scrollTop
        //     ];
        //     var html = jQuery('html'); // it would make more sense to apply this to body, but IE7 won't have that
        //     html.data('scroll-position', scrollPosition);
        //     html.data('previous-overflow', html.css('overflow'));
        //     html.css('overflow', 'hidden');
        //     window.scrollTo(scrollPosition[0], scrollPosition[1]);
        // });

        // $('.off-canvas--overlay').on('click', function() {
        //     var html = $('html');
        //     var scrollPosition = html.data('scroll-position');
        //     html.css('overflow', html.data('previous-overflow'));
        //     window.scrollTo(scrollPosition[0], scrollPosition[1])
        // });

        /**
         * Testimonials
         */
        var testimonialsContainer = $('.custom-testimonials-section .slideshow');
        testimonialsContainer.slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 4,
            autoplay: true,
            arrows: true,
            slidesToScroll: 2,
            prevArrow: '<svg class="Icon Icon--media-arrow-left" role="presentation" viewBox="0 0 6 9"><path d="M5 8.5l-4-4 4-4" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg>',
            nextArrow: '<svg class="Icon Icon--media-arrow-right" role="presentation" viewBox="0 0 6 9"><path d="M1 8.5l4-4-4-4" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg>',
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true
                  }
                },
                {
                  breakpoint: 600,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                },
                {
                  breakpoint: 350,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                  }
                }
            ]
        });

        /**
         * FAQs and Video
         */
        $(".so-accordion-wrapper .so-tab > label").on("click", function() {
            if ($(this).hasClass("active")) {
              $(this).removeClass("active");
              $(this)
                .siblings(".so-tab-content")
                .slideUp(200);
              $(".set > a i")
                .removeClass("fa-minus")
                .addClass("fa-plus");
            } else {
              $(".set > a i")
                .removeClass("fa-minus")
                .addClass("fa-plus");
              $(this)
                .find("i")
                .removeClass("fa-plus")
                .addClass("fa-minus");
              $(".so-accordion-wrapper .so-tab > label").removeClass("active");
              $(this).addClass("active");
              $(".so-tab-content").slideUp(200);
              $(this)
                .siblings(".so-tab-content")
                .slideDown(200);
            }
        });

        $('.video-block .preholder-image .play-button').on('click', function(e) {
            e.preventDefault();
            $(this).parents('.preholder-image').fadeOut();
            $('#header_video').show();
            $('#header_video')[0].src += "&autoplay=1";
        })
    });

})(jQuery)